module.exports = __webpack_public_path__ + "img/s4Model1.b5d0d11c.webp";